export const MariaDBKeywords: string[] = [];
